<template>
	<!-- Tipo 'alone': botões independentes -->
	<div class="tag-choice-wrapper" v-if="type === 'alone'">
		<button
			v-for="(option, index) in options"
			role="button"
  		:aria-pressed="selectedValue === option.value"
			:key="index"
			class="tag-choice"
			:class="{ active: selectedValue === option.value }"
			:style="{ marginRight: spacing + 'px' }"
			@click="selectOption(option)"
		>
			{{ option.label }}
		</button>
	</div>

	<!-- Tipo 'group': botões conectados visualmente -->
	<div class="tag-choice-group" v-else-if="type === 'group'">
		<button
			v-for="(option, index) in options"
			:key="index"
			class="tag-choice group"
			:class="{
				active: selectedValue === option.value,
				first: index === 0,
				last: index === options.length - 1,
			}"
			@click="selectOption(option)"
		>
			{{ option.label }}
		</button>
	</div>
</template>

<script>
export default {
  name: 'TagChoice',

  props: {
    type: {
      type: String,
      default: 'alone'
    },
    options: {
      type: Array,
      required: true
    },
    spacing: {
      type: Number,
      default: 10
    },
    modelValue: {
      type: [String, Number],
      default: ''
    }
  },

  data() {
    return {
      selectedValue: this.modelValue
    }
  },

  watch: {
    modelValue(val) {
      this.selectedValue = val
    }
  },

  methods: {
    selectOption(option) {
      this.selectedValue = option.value
      this.$emit('update:modelValue', option.value)
      this.$emit('change', option)
    }
  }
}
</script>

<style scoped lang="stylus">
@import 'styles.styl'
</style>
